import _ from 'lodash';
import React, { useState } from 'react';
import MaterialDesignDialog from '../../general/MaterialDesignDialog.react';
import ReservationConstants from '../../../constants/ReservationConstants';
import Button from '@mui/material/Button';
import ReservationActions from '../../../actions/ReservationActions';
import { useTranslation } from 'react-i18next';

const RequestModals = ({
	activeRequest,
	showApprovalModal,
	showRejectionModal,
	setShowApprovalModal,
	setShowRejectionModal,
	setActiveRequest,
	setApprovalModalProgress,
    isNeedCheckDoubleBooking,
	isInProgress,
}) => {
	const reservation = _.get(activeRequest, 'reservation');

	const { t } = useTranslation();

	const [rejectReason, setRejectReason] = useState('');

	const getApprovalModalFooter = () => {
		return reservation.status !== ReservationConstants.RESERVATION_STATUS.APPROVING && !isInProgress ? (
			<div className="approve-modal-actions">
				<Button
					color="primary"
					onClick={() => {
						if (isNeedCheckDoubleBooking) {
							ReservationActions.checkDoubleBooking({
								reservation_id: reservation?.id,
								check_in: _.get(reservation, 'deal.details.check_in'),
								check_out: _.get(reservation, 'deal.details.check_out'),
								travellers: reservation.travelers,
								company_id: activeRequest.request_ticket.company,
								user_id: activeRequest.request_ticket.creator,
							});
							setApprovalModalProgress(true);
						} else {
							ReservationActions.approveReservation(activeRequest);
							ReservationActions.clearReservation();
							setShowApprovalModal(false);
						}
					}}
				>
					{t('ImSure')}
				</Button>
				<Button color="primary" onClick={() => setShowApprovalModal(false)}>
					{t('TakeMeBack')}
				</Button>
			</div>
		) : (
			<div className="approving-modal-status">
				<i title={t('ApprovingReservation')} className="fa fa-spin fa-spinner" />
				<span>{t('Approving')}</span>
			</div>
		);
	};

	const getApprovalModalFailedFooter = () => {
		return (
			<div className="approving-modal-status">
				<span>{t('ApprovalFailed')}</span>
				<br />
				<span>
					{t('ContactSupport')}{' '}
					<a href={`mailto:${t('HelpEmail')}`} target="_blank" rel="noreferrer">
						{t('SupportTeam')}
					</a>
					.
				</span>
				<br />
				<Button color="primary" onClick={() => setShowApprovalModal(false)}>
					{t('OK')}
				</Button>
			</div>
		);
	};

	const getRejectModalFooter = () => {
		return reservation.status !== ReservationConstants.RESERVATION_STATUS.REJECTING ? (
			<div className="reject-modal-actions">
				<Button
					color="primary"
					onClick={() => {
						ReservationActions.rejectReservation(Object.assign({ reason: rejectReason }, activeRequest));
						setShowRejectionModal(false);
					}}
				>
					{t('ImSure')}
				</Button>
				<Button color="primary" onClick={() => setShowRejectionModal(false)}>
					{t('TakeMeBack')}
				</Button>
			</div>
		) : (
			<div className="rejecting-modal-status">
				<i title={t('DecliningReservation')} className="fa fa-spin fa-spinner" />
				<span>{t('Declining')}</span>
			</div>
		);
	};

	const getRejectModalFailedFooter = () => {
		return (
			<div className="rejecting-modal-status">
				<span>{t('DeclineFailed')}</span>
				<br />
				<span>
					{t('ContactSupport')}{' '}
					<a href={`mailto:${t('HelpEmail')}`} target="_blank" rel="noreferrer">
						{t('SupportTeam')}
					</a>
					.
				</span>
				<br />
				<Button color="primary" onClick={() => setShowRejectionModal(false)}>
					{t('OK')}
				</Button>
			</div>
		);
	};

	if (!reservation) {
		return null;
	}

	return (
		<React.Fragment>
			<MaterialDesignDialog
				open={showApprovalModal || reservation.status === ReservationConstants.RESERVATION_STATUS.APPROVING}
				onClose={() => {
					setShowApprovalModal(false);
					setActiveRequest({});
				}}
				closeTimeoutInMilliseconds={150}
				key={`approve-modal-${reservation.id}`}
				title={t('ApproveReservation')}
				content={
					<React.Fragment>
						<div className="approve-reservation-modal-content">
							<div className="description">
								{_.get(reservation, 'deal.dca.cancellationPoliciesText') && (
									<span>{t('ReviewCancellationTerms')}</span>
								)}
							</div>
							<div className="cancellation-policy">
								{_.get(reservation, 'deal.dca.cancellationPoliciesText')}
							</div>
						</div>
						{reservation.approveStatus !== ReservationConstants.STATUS.FAILED
							? getApprovalModalFooter()
							: getApprovalModalFailedFooter()}
					</React.Fragment>
				}
			/>

			<MaterialDesignDialog
				open={showRejectionModal || reservation.status === ReservationConstants.RESERVATION_STATUS.REJECTING}
				onClose={() => setShowRejectionModal(false)}
				closeTimeoutInMilliseconds={150}
				key={`reject-modal-${reservation.id}`}
				title={t('DeclineReservation')}
				content={
					<React.Fragment>
						<div className="reject-reservation-modal-content">
							<div className="reason-container">
								<label htmlFor="reject-reason">{t('DeclineReason')}</label>
								<span className="reject-notice">{t('DeclineNotice')}</span>
								<div className="text-box-container">
									<textarea
										placeholder={t('Optional')}
										className="text-box"
										onChange={(e) => setRejectReason(e.target.value)}
										value={rejectReason}
									/>
								</div>
							</div>
						</div>
						{reservation.rejectStatus !== ReservationConstants.STATUS.FAILED
							? getRejectModalFooter()
							: getRejectModalFailedFooter()}
					</React.Fragment>
				}
			/>
		</React.Fragment>
	);
};

export default RequestModals;
